import { useCallback } from 'react'

import { resetCrudSelection } from '@/atoms'
import { DownloadKML } from '@/icons'
import { Delete, Edit } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'
import { RoutingSegmentAvatar } from '../../components/RoutingSegmentAvatar'
import { ViewDetails } from '../../components/ViewDetails'

import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

import { useDeleteRoadSegmentModal } from '../../../modals/DeleteRoadSegmentModal'

interface Props {
  roadSegment: uui.domain.client.rm.SegmentException
}

export function SingleView(props: Props) {
  const { roadSegment } = props
  const { name, malus, additionalDrivingTimeSec } = roadSegment

  const texts = useTexts()
  const actions = useActions(roadSegment)

  const onReset = useCallback(() => {
    resetCrudSelection('routingSegments')
  }, [])

  const { Modal: DeleteRoadSegmentModal } = useDeleteRoadSegmentModal()

  return (
    <preview.Root
      applyPendingFitMapOnMount
      header={
        <preview.Header
          title={texts.title(name)}
          onClose={onReset}
          avatar={<RoutingSegmentAvatar segment={roadSegment} size={40} />}
          testId="road-segment-view-header"
        >
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<Edit />}
              onClick={actions.onEdit}
              label={texts.edit}
              tooltip={texts.edit}
              disableWhenReadOnly
              testId="setup-road-segment__edit"
              data-trackid="setup-road-segment__edit"
            />
            <preview.ActionBarItem
              icon={<DownloadKML size={24} />}
              onClick={actions.onExport}
              label={texts.exportKML}
              tooltip={texts.exportKML}
              testId="setup-road-segment__exportkml"
              data-trackid="setup-road-segment__exportkml"
              disableWhenReadOnly={false}
            />
            <preview.ActionBarItem
              icon={<Delete />}
              onClick={actions.onDelete}
              label={texts.delete}
              tooltip={texts.delete}
              testId="setup-road-segment__delete"
              data-trackid="setup-road-segment__delete"
              disableWhenReadOnly
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <ViewDetails additionalDrivingTimeSec={additionalDrivingTimeSec} malus={malus} />

      <DeleteRoadSegmentModal roadSegments={[roadSegment.id]} />
    </preview.Root>
  )
}
